import React from 'react'
import { Text, MapWidget, MapMenu, MapItem, MapLayer, MapOverlay, MessageTooltip } from 'components/library'
import { Layer } from 'components/library/widgets/map/components'
import mapBaseImage from 'components/library/widgets/map/assets/baseMap-01.svg'
import layer01 from './assets/maplayer_2_3_1-01.svg'


import './C02A03Tab01.css'

class C02A03Tab01 extends React.Component {

  render() {
    return (
      <div className="C02A03Tab01">
        <MapWidget
          mapImage={mapBaseImage}
          mapBounds={[[0, 0], [3556, 3406]]}
          options={{ minZoom: -1.5 }}>

          <MapMenu>
            <MapItem center={[2082,2325]} zoom={-0.85}>
              <MapOverlay>
                <div className="Content-menu-tab-01">
                  <MessageTooltip>
                    <Text>In hoofdstuk 1 heb je gezien wat de standaard routes zijn wanneer je tussen Schiphol-Centrum en Schiphol-Oost moet slepen. Het kan echter voorkomen dat Apron Control je een alternatieve route geeft. Dit gebeurt alleen als er aan de voorwaarden is voldaan:</Text>
                    <ul style={{ margin: '2rem 0'}}>
                      <li>Er is geen sprake van BZO</li>
                      <li>Baan 18L-36R is niet beschikbaar gesteld aan de LVNL</li>
                      <li>Baan 04-22 is niet beschikbaar gesteld aan de LVNL</li>
                    </ul>
                    <Text>Indien er aan de voorwaarden voldaan is stemt, Apron Control de alternatieve route met LVNL af.</Text>
                  </MessageTooltip>
                  <div className="Map-legend">
                    <div>
                      <div className="Map-legend-items item-01">
                        <span></span>
                        <Text>Schiphol-Centrum - Schiphol-Oost</Text>
                      </div>
                      <div className="Map-legend-items item-02">
                        <span></span>
                        <Text>Schiphol-Oost - Schiphol-Centrum</Text>
                      </div>
                    </div>
                  </div>
                </div>
              </MapOverlay>
              <MapLayer>
                <Layer url={layer01} bounds={[[0, 0], [3556, 3406]]} />
              </MapLayer>
            </MapItem>
          </MapMenu>
        </MapWidget>
      </div>
    )
  }
}

export default C02A03Tab01



// WEBPACK FOOTER //
// ./src/content/chapters/02/03/components/c02_a03_tab_01/C02A03Tab01.js